import React, { FC, Suspense, lazy } from 'react'
import { useParams } from 'react-router-dom'
import { Loading } from '../../../../../modules/common/loading/Loading'

const OrganizationConstellationsView = lazy(() => import('../../../../../modules/organizations/views/organization-constellations-view/OrganizationConstellationsView'))

export const OrganizationConstellationsRoute: FC = () => {

	// params
	const { organization_id } = useParams() as { organization_id: string }

	return (
		<Suspense fallback={<Loading />}>
			<OrganizationConstellationsView organizationId={organization_id} />
		</Suspense>
	)
}